<template>
  <section class="section-block">
    <div class="section-title">处理目标选择模块</div>
    <div class="target-toolbar">
      <el-button size="mini" @click="selectAll('platform')">全选平台</el-button>
      <el-button size="mini" @click="clearSelection('platform')">清空平台</el-button>
      <el-button size="mini" @click="selectAll('store')">全选店铺</el-button>
      <el-button size="mini" @click="clearSelection('store')">清空店铺</el-button>
    </div>

    <div class="target-grid">
      <div class="target-panel">
        <div class="mini-title">目标平台组</div>
        <el-table
          ref="platformTable"
          :data="platformRows"
          border
          size="mini"
          :row-key="getRowKey1"
          @selection-change="handlePlatformSelectionChange"
          :header-cell-style="{ backgroundColor: '#FAFAFA', textAlign: 'center' }"
          :cell-style="{ textAlign: 'center' }"
          height="220"
        >
          <el-table-column type="selection" width="42" :reserve-selection="true" />
          <el-table-column prop="groupName" label="平台组" min-width="90" />
          <el-table-column prop="applicableStoreNote" label="可选店铺" min-width="90" show-overflow-tooltip />
          <el-table-column prop="currentVersion" label="规则版本" min-width="110" />
          <el-table-column prop="statusDesc" label="发布状态" min-width="90" />
        </el-table>
      </div>

      <div class="target-panel">
        <div class="mini-title">目标店铺</div>
        <el-table
          ref="storeTable"
          :data="storeRows"
          border
          size="mini"
          :row-key="getRowKey2"
          @selection-change="handleStoreSelectionChange"
          :header-cell-style="{ backgroundColor: '#FAFAFA', textAlign: 'center' }"
          :cell-style="{ textAlign: 'center' }"
          height="220"
        >
          <el-table-column type="selection" width="42" :reserve-selection="true" />
          <el-table-column prop="groupName" label="平台组" min-width="90" />
          <el-table-column prop="storeName" label="店铺简称" min-width="100" />
          <el-table-column prop="currentVersion" label="规则版本" min-width="110" />
          <el-table-column prop="storeName" label="店铺名称" min-width="160" show-overflow-tooltip />
          <el-table-column prop="statusDesc" label="授权状态" min-width="90" />
        </el-table>
      </div>
    </div>

    <div class="target-panel target-panel-bottom">
      <div class="mini-title">商品与规格关联映射</div>
      <el-table
        ref="productTable"
        :data="productRows"
        border
        size="mini"
        :row-key="getRowKey3"
        @selection-change="handleProductSelectionChange"
        :header-cell-style="{ backgroundColor: '#FAFAFA', textAlign: 'center' }"
        :cell-style="{ textAlign: 'center' }"
        height="220"
      >
        <el-table-column type="selection" width="42" :reserve-selection="true" />
        <el-table-column prop="model" label="产品型号" min-width="120" />
        <el-table-column prop="groupName" label="平台" min-width="90" />
        <el-table-column prop="platformSpu" label="平台商品编码" min-width="140" />
        <el-table-column prop="storeName" label="匹配店铺" min-width="140" show-overflow-tooltip />
        <el-table-column prop="skuNum" label="规格数量" min-width="90" />
      </el-table>
    </div>

    <div class="target-panel target-panel-bottom">
      <div class="mini-title">销售属性图映射</div>
      <el-table
        :data="salesPropertyImageMapRows"
        border
        size="mini"
        :header-cell-style="{ backgroundColor: '#FAFAFA', textAlign: 'center' }"
        :cell-style="{ textAlign: 'center' }"
        height="220"
      >
        <el-table-column prop="platformSku" label="平台规格编码" min-width="140" show-overflow-tooltip />
        <el-table-column prop="skuCode" label="规格编码" min-width="120" show-overflow-tooltip />
        <el-table-column prop="skuName" label="销售属性名称" min-width="140" show-overflow-tooltip />
        <el-table-column prop="storeName" label="店铺" min-width="140" show-overflow-tooltip />
        <el-table-column prop="srcFileName" label="独立销售属性源图" min-width="160" show-overflow-tooltip />
        <el-table-column prop="srcParam" label="源图参数" min-width="140" show-overflow-tooltip />
        <el-table-column prop="precheck" label="预检" min-width="100">
          <template slot-scope="{ row }">
            <span class="success-text">{{ displayValue(row.precheck) }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="target-panel target-panel-bottom">
      <div class="mini-title title-with-extra">
        <span>源素材实际参数</span>
        <span class="title-tip">以设计师实际上传文件为准。</span>
        <el-button type="text" size="mini" class="preview-material-btn" @click="handlePreviewMaterial">
          {{ materialPreviewVisible ? '收起素材' : '预览素材' }}
        </el-button>
      </div>
      <el-table
        :data="sourceMaterialActualParamRows"
        border
        size="mini"
        :header-cell-style="{ backgroundColor: '#FAFAFA', textAlign: 'center' }"
        :cell-style="{ textAlign: 'center' }"
        height="220"
      >
        <el-table-column prop="type" label="源素材类型" min-width="130" show-overflow-tooltip />
        <el-table-column prop="fileName" label="源文件" min-width="180" show-overflow-tooltip />
        <el-table-column prop="size" label="实际尺寸" min-width="120" show-overflow-tooltip />
        <el-table-column prop="format" label="格式" min-width="90" show-overflow-tooltip />
        <el-table-column prop="capacity" label="容量" min-width="100" show-overflow-tooltip />
        <el-table-column prop="num" label="数量" min-width="90" show-overflow-tooltip />
      </el-table>
      <material-preview v-if="materialPreviewVisible" />
    </div>
  </section>
</template>

<script>
import { debounce } from '@/utils/index'
import MaterialPreview from './MaterialPreview.vue'

const mockSourceMaterialActualParamRows = [
  { type: '1:1主图', fileName: '', size: '1440×1440', format: 'JPG', capacity: '12.7MB', num: 5 },
  { type: '3:4主图', fileName: '', size: '1440×1920', format: 'JPG', capacity: '13.6MB', num: 5 },
  { type: '详情图', fileName: '', size: '1440×51840', format: 'JPG', capacity: '6MB', num: 1 },
  { type: '销售属性图', fileName: '', size: '1600×1600', format: 'JPG', capacity: '1.75MB', num: 6 },
  { type: '透明素材图', fileName: '', size: '1600×1600', format: 'JPG', capacity: '1.4MB', num: 1 }
]

export default {
  name: 'StoreGoodsImageStepOne',
  components: {
    MaterialPreview
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      platformRows: [],
      storeRows: [],
      productRows: [],
      salesPropertyImageMapRows: [],
      sourceMaterialActualParamRows: [],
      selectedPlatformRows: [],
      selectedStoreRows: [],
      selectedProductRows: [],
      loading: false,
      productRequestId: 0,
      storeRequestId: 0,
      skuRequestId: 0,
      platformSelectionVersion: 0,
      storeSelectionVersion: 0,
      productSelectionVersion: 0,
      materialPreviewVisible: false
    }
  },
  created () {
    this.debouncedPlatformSelectionChange = debounce(this.applyPlatformSelectionChange, 100)
    this.debouncedStoreSelectionChange = debounce(this.applyStoreSelectionChange, 100)
    this.debouncedProductSelectionChange = debounce(this.applyProductSelectionChange, 100)
  },
  beforeDestroy () {
    this.platformSelectionVersion += 1
    this.storeSelectionVersion += 1
    this.productSelectionVersion += 1
  },
  watch: {
    visible: {
      immediate: true,
      handler (val) {
        if (val) {
          this.initData()
        } else {
          this.materialPreviewVisible = false
        }
      }
    },
    rowData: {
      deep: true,
      handler () {
        if (this.visible) {
          this.initData()
        }
      }
    }
  },
  methods: {
    async initData () {
      this.loading = true
      this.productRequestId += 1
      this.storeRequestId += 1
      this.skuRequestId += 1
      this.platformSelectionVersion += 1
      this.storeSelectionVersion += 1
      this.productSelectionVersion += 1
      this.platformRows = []
      this.storeRows = []
      this.productRows = []
      this.salesPropertyImageMapRows = []
      this.sourceMaterialActualParamRows = []
      this.selectedPlatformRows = []
      this.selectedStoreRows = []
      this.selectedProductRows = []
      this.emitBasicInfoChange()
      try {
        await this.loadPlatformRows()
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    async loadPlatformRows () {
      const modelName = this.getModelName()
      if (!modelName) {
        this.emitBasicInfoChange()
        return
      }
      const platformRes = await this.$q.newProduct.listTargetPlatformGroup({ params: { modelName } })
      this.platformRows = this.getResponseRows(platformRes)
      this.$nextTick(() => {
        const firstRow = this.platformRows[0]
        if (firstRow && this.$refs.platformTable && this.$refs.platformTable.toggleRowSelection) {
          this.$refs.platformTable.toggleRowSelection(firstRow, true)
          this.handlePlatformSelectionChange([firstRow])
        }
      })
      this.emitBasicInfoChange()
    },
    async loadStoreRows (selectedPlatformRows) {
      const modelName = this.getModelName()
      const currentPlatformRows = selectedPlatformRows || this.selectedPlatformRows
      const groupCodes = currentPlatformRows.map(item => item.groupCode).filter(Boolean).join(',')
      const requestId = ++this.storeRequestId
      this.productRequestId += 1
      this.storeRows = []
      this.productRows = []
      this.salesPropertyImageMapRows = []
      this.sourceMaterialActualParamRows = []
      this.selectedStoreRows = []
      this.selectedProductRows = []
      if (!modelName || !groupCodes.length) {
        this.emitBasicInfoChange()
        return
      }
      const storeRes = await this.$q.newProduct.listTargetStore({
        params: {
          modelName,
          groupCodes
        }
      })
      if (requestId !== this.storeRequestId) {
        return
      }
      this.storeRows = this.getResponseRows(storeRes)
      this.$nextTick(() => {
        const firstRow = this.storeRows[0]
        if (firstRow && this.$refs.storeTable && this.$refs.storeTable.toggleRowSelection) {
          this.$refs.storeTable.toggleRowSelection(firstRow, true)
          this.handleStoreSelectionChange([firstRow])
        }
      })
      this.emitBasicInfoChange()
    },
    async loadProductRows (selectedStoreRows) {
      const modelName = this.getModelName()
      const currentStoreRows = selectedStoreRows || this.selectedStoreRows
      const storeCodes = currentStoreRows.map(item => item.storeCode).filter(Boolean).join(',')
      const requestId = ++this.productRequestId
      this.productRows = []
      this.salesPropertyImageMapRows = []
      this.sourceMaterialActualParamRows = []
      this.selectedProductRows = []
      if (!modelName || !storeCodes.length) {
        this.emitBasicInfoChange()
        return
      }
      const spuRes = await this.$q.newProduct.listImageTaskSpu({
        params: {
          modelName,
          storeCodes
        }
      })
      if (requestId !== this.productRequestId) {
        return
      }
      this.productRows = this.getResponseRows(spuRes)
      this.$nextTick(() => {
        const firstRow = this.productRows[0]
        if (firstRow && this.$refs.productTable && this.$refs.productTable.toggleRowSelection) {
          this.$refs.productTable.toggleRowSelection(firstRow, true)
          this.handleProductSelectionChange([firstRow])
        }
      })
      this.emitBasicInfoChange()
    },
    async loadSkuAndSrcPicRows () {
      const requestId = ++this.skuRequestId
      const spuCodes = this.selectedProductRows.map(item => item.platformSpu).filter(Boolean).join(',')
      this.salesPropertyImageMapRows = []
      this.sourceMaterialActualParamRows = []
      if (!spuCodes.length) {
        this.emitBasicInfoChange()
        return
      }
      const params = { spuCodes }
      const skuRes = await this.$q.newProduct.listImageTaskSku({ params })
      if (requestId !== this.skuRequestId) {
        return
      }
      await this.$q.newProduct.listImageTaskSrcPic({ params })
      if (requestId !== this.skuRequestId) {
        return
      }
      this.salesPropertyImageMapRows = this.getResponseRows(skuRes)
      this.sourceMaterialActualParamRows = mockSourceMaterialActualParamRows
      this.emitBasicInfoChange()
      return this.sourceMaterialActualParamRows
    },
    emitBasicInfoChange () {
      this.$emit('basic-info-change', this.buildSummaryCards())
    },
    emitSelectionChange () {
      this.$emit('selection-change', {
        platformRows: this.selectedPlatformRows,
        storeRows: this.selectedStoreRows,
        productRows: this.selectedProductRows
      })
    },
    buildSummaryCards () {
      const row = this.rowData || {}
      return [
        { label: '产品型号', value: row.productModel || row.goodsCode || this.getModelName() || '-' },
        { label: '标准源素材', value: row.sourceMaterialCode || row.noticeCode || row.id || '-' },
        { label: '目标平台组', value: row.targetPlatformCount || this.platformRows.length || '-' },
        { label: '目标店铺', value: row.targetStoreCount || this.storeRows.length || '-' },
        { label: '已选平台商品', value: row.selectedPlatformGoodsCount || this.productRows.length || '-' },
        { label: '可替换商品规格', value: row.replaceSpecCount || '-' }
      ]
    },
    getRowKey1 (row) {
      return row.groupCode
    },
    getRowKey2 (row) {
      return row.storeCode
    },
    getRowKey3 (row) {
      return row.platformSpu
    },
    getModelName () {
      const row = this.rowData || {}
      return row.productModel || row.modelName || row.model || row.goodsCode || ''
    },
    getResponseRows (res) {
      if (Array.isArray(res)) return res
      const data = res && res.data
      if (Array.isArray(data)) return data
      if (data && Array.isArray(data.data)) return data.data
      if (data && Array.isArray(data.dataList)) return data.dataList
      return []
    },
    displayValue (value) {
      return value || value === 0 ? value : '-'
    },
    handlePreviewMaterial () {
      this.materialPreviewVisible = !this.materialPreviewVisible
    },
    selectAll (type) {
      const refMap = {
        platform: 'platformTable',
        store: 'storeTable',
        product: 'productTable'
      }
      const dataMap = {
        platform: this.platformRows,
        store: this.storeRows,
        product: this.productRows
      }
      const table = this.$refs[refMap[type]]
      const rows = dataMap[type] || []
      if (!table || !table.toggleRowSelection) return
      rows.forEach(row => table.toggleRowSelection(row, true))
    },
    clearSelection (type) {
      const refMap = {
        platform: 'platformTable',
        store: 'storeTable',
        product: 'productTable'
      }
      const table = this.$refs[refMap[type]]
      if (table && table.clearSelection) {
        table.clearSelection()
      }
      if (type === 'platform') {
        this.handlePlatformSelectionChange([])
      }
      if (type === 'store') {
        this.handleStoreSelectionChange([])
      }
      if (type === 'product') {
        this.handleProductSelectionChange([])
      }
    },
    handlePlatformSelectionChange (val) {
      const selectedRows = val || []
      const version = ++this.platformSelectionVersion
      this.storeSelectionVersion += 1
      this.productSelectionVersion += 1
      this.clearTableSelection('storeTable')
      this.clearTableSelection('productTable')
      this.selectedPlatformRows = selectedRows
      this.selectedStoreRows = []
      this.selectedProductRows = []
      this.storeRequestId += 1
      this.productRequestId += 1
      this.skuRequestId += 1
      this.storeRows = []
      this.productRows = []
      this.salesPropertyImageMapRows = []
      this.sourceMaterialActualParamRows = []
      this.emitSelectionChange()
      this.debouncedPlatformSelectionChange(selectedRows, version)
    },
    handleStoreSelectionChange (val) {
      const selectedRows = (val || []).filter(row => this.storeRows.indexOf(row) !== -1)
      const version = ++this.storeSelectionVersion
      this.productSelectionVersion += 1
      this.clearTableSelection('productTable')
      this.selectedStoreRows = selectedRows
      this.selectedProductRows = []
      this.productRequestId += 1
      this.skuRequestId += 1
      this.productRows = []
      this.salesPropertyImageMapRows = []
      this.sourceMaterialActualParamRows = []
      this.emitSelectionChange()
      this.debouncedStoreSelectionChange(selectedRows, version)
    },
    handleProductSelectionChange (val) {
      const selectedRows = (val || []).filter(row => this.productRows.indexOf(row) !== -1)
      const version = ++this.productSelectionVersion
      this.selectedProductRows = selectedRows
      this.skuRequestId += 1
      this.salesPropertyImageMapRows = []
      this.sourceMaterialActualParamRows = []
      this.emitSelectionChange()
      this.debouncedProductSelectionChange(version)
    },
    clearTableSelection (refName) {
      const table = this.$refs[refName]
      if (table && table.clearSelection) {
        table.clearSelection()
      }
    },
    applyPlatformSelectionChange (selectedRows, version) {
      if (version !== this.platformSelectionVersion) return
      this.loadStoreRows(selectedRows)
    },
    applyStoreSelectionChange (selectedRows, version) {
      if (version !== this.storeSelectionVersion) return
      this.loadProductRows(selectedRows)
    },
    applyProductSelectionChange (version) {
      if (version !== this.productSelectionVersion) return
      this.loadSkuAndSrcPicRows()
    }
  }
}
</script>

<style lang="stylus" scoped>
.section-block
  margin-bottom 16px

.section-title,
.mini-title
  font-size 14px
  font-weight 600
  color #303133
  margin-bottom 10px

.target-toolbar
  display flex
  gap 8px
  margin-bottom 12px
  flex-wrap wrap

.target-grid
  display grid
  grid-template-columns 1fr 1fr
  gap 12px

.target-panel
  background #fff
  border 1px solid #ebeef5
  border-radius 6px
  padding 12px

.target-panel-bottom
  margin-top 12px

.title-with-extra
  display flex
  align-items center
  gap 8px

.title-tip
  color #909399
  font-size 12px
  font-weight 400

.preview-material-btn
  padding 0
  color #67c23a

.preview-material-btn:hover,
.preview-material-btn:focus
  color #85ce61

.success-text
  color #67c23a

>>> .el-table__body-wrapper
  overflow auto

@media (max-width: 1200px)
  .target-grid
    grid-template-columns 1fr
</style>
